module.exports = __webpack_public_path__ + "static/media/car3.435462b9.webp";